import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@mui/material";
import styles from "./toolbarButton.module.css";
import React, { JSX } from "react";

interface ToolbarButtonProps {
  icon: JSX.Element;
  label: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  color: string | undefined;
  disabled?: boolean;
  trailingAdornment?: React.ReactNode;
  /** The action's id, by which the tutorial can point at the button. */
  tourId?: string;
}

export default function ToolbarButton({
  icon,
  label,
  onClick,
  color,
  disabled = false,
  trailingAdornment,
  tourId,
}: ToolbarButtonProps) {

  return (
    <Box className={styles.menuBox} data-tour-action={tourId}>
      <Card className={styles.menuCard} onClick={disabled ? undefined : onClick} sx={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'not-allowed' : 'pointer' }}>
        <CardActionArea disabled={disabled}>
          <CardContent className={styles.menuCardContent}>
            <Box
              className={styles.iconBox}
              style={{ background: color || "var(--colorfulBg)" }}
            >
              {React.cloneElement(icon, { style: { fontSize: "18px" } })}
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "80%" }}>
              <Typography className={styles.menuButtonLabel} variant="body2">
                {label}
              </Typography>
              {trailingAdornment}
            </Box>
          </CardContent>
        </CardActionArea>
      </Card>
    </Box>
  );
}
